// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconHamburgerMenu.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconHamburgerMenu = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M15 2C15.5523 2 16 2.44772 16 3C16 3.55229 15.5523 4 15 4L1 4C0.447715 4 -2.41411e-08 3.55228 0 3C2.41411e-08 2.44772 0.447715 2 1 2L15 2Z" />
    <path d="M15 7C15.5523 7 16 7.44772 16 8C16 8.55229 15.5523 9 15 9L1 9C0.447715 9 -2.41411e-08 8.55228 0 8C2.41411e-08 7.44772 0.447715 7 1 7L15 7Z" />
    <path d="M15 12C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14L1 14C0.447715 14 -2.41411e-08 13.5523 0 13C2.41411e-08 12.4477 0.447715 12 1 12L15 12Z" />
  </BaseIcon>
);

export default IconHamburgerMenu;
